export const AMPLITUDE_ONBOARDING_SURVEY_VERSION = 'v3.2'

/**
 * To add a new Amplitude feature flag:
 * 1. Add the flag to the KitsAI - Development project with the correct values
 * 2. Set the flag to 100% all users included in the flag
 * 3. Choose the deployments for the flag to be in (api and client)
 * 4. Copy the flag across projects to the KitsAI - Production project
 * 5. Repeat the above steps for the prod project, especially step 3
 * 6. Add the flag here
 * 7. Access with useFlags() hook in kits-ui or in the FeatureFlagService on the API
 */
export enum FeatureFlags {
  QUICK_VOICE_CLONING = 'quick-voice-cloning',
  INFERENCE_FILE_UPLOAD_LOCATION = 'inference-file-upload-location',
  STEM_SPLITTER_FILE_UPLOAD_LOCATION = 'stem-splitter-file-upload-location',
  AUDIO_ANALYSIS_JOB_FILE_UPLOAD_LOCATION = 'audio-analysis-file-upload-location',
  INSTANT_VOICE_CLONING = 'instant-voice-cloning',
  SHOW_DEBREATH_INFERENCE_OPTION = 'show-debreath-inference-option',
  SHOW_WIDEN_OPTION_INFERENCE = 'show-widen-option-inference',
  ZERO_SHOT_INFERENCE_ENABLED = 'zero-shot-inference-enabled',
  CHOIR_TOOL_ENABLED = 'choir-tool-enabled',
  MODEL_FILE_UPLOAD_LOCATION = 'model-file-upload-location',
  AUTOEQ_ON_BY_DEFAULT = 'auto-eq-on-by-default',
  ENABLE_AUTOEQ = 'enable-autoeq',
  IS_UNDER_CONSTRUCTION = 'is-under-construction',
  INFERENCE_PITCH_METHOD = 'inference-pitch-method',
  DEFAULT_VOCAL_REMOVER_MODEL = 'default-vocal-remover-model',
  MY_FIRST_CONVERSION_TOUR = 'my-first-conversion-tour',
  SHOW_DISCORD_LINK = 'show-discord-link',
  REMOVE_SILENCE_INFERENCE = 'remove-silence-inference',
  DENOISE_PAGE_ENABLED = 'denoise-page-enabled',
  DEHARMONY_PAGE_ENABLED = 'deharmony-page-enabled',
  DEREVERB_PAGE_ENABLED = 'dereverb-page-enabled',
  INFERENCE_SPLIT_INSTRUMENTAL = 'inference-split-instrumental',
  INFERENCE_DEHARMONY = 'inference-deharmony',
  INFERENCE_DEREVERB = 'inference-dereverb',
  TRAINING_SPLIT_INSTRUMENTAL = 'training-split-instrumental',
  TRAINING_DEREVERB = 'training-dereverb',
  TRAINING_DEHARMONY = 'training-deharmony',
  NORMALIZE_INFERENCE = 'normalize-inference',
  AUTOTUNE_SHOW_KERNEL_SIZE = 'autotune-show-kernel-size',
  AUTOTUNE_SHOW_CORRECTION_STRENGTH = 'autotune-show-correction-strength',
  INFERENCE_ADVANCED_SETTINGS_ONLY_FOR_PAID_USERS = 'inference-advanced-settings-only-for-paid-users',
  PRESELECT_VOICE_103124 = 'preselect-voice-103124',
  AUTH_GATE = 'auth-gate',
  STUDIO = 'studio',
  ONBOARDING_FREE_TRIAL = 'onboarding-free-trial',
  HYBRID_PITCH_ENABLED = 'hybrid-pitch-enabled'
}

export const getAmplitudeDeploymentKey = (isProd: boolean) => {
  return isProd
    ? 'client-fQwwlWh1E1gxmYYAqDW3Onu7lVWbsUzL'
    : 'client-f0g2vG0Uh1qFJTh0MQ1ab7TIiNPnGHJ8'
}
